import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const TriggerButton = styled.button`
  ${({ theme }) => css`
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 8px;

    &:hover {
      background: ${theme.v2.colors.neutral.highLight};
    }
  `}
`;

export const DropdownMenu = styled.div`
  ${({ theme }) => css`
    position: absolute;
    right: 0;
    top: calc(100% + 8px);
    background: ${theme.v2.colors.neutral.highPure};
    border-radius: 8px;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.08);
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    z-index: 10;
    min-width: 270px;
  `}
`;

export const DropdownItem = styled.button`
  ${({ theme }) => css`
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 8px;
    border-radius: 8px;
    cursor: pointer;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.neutral.lowDark};
    background: ${theme.v2.colors.neutral.highPure};
    border: none;
    width: 100%;
    text-align: left;

    &:hover {
      background: ${theme.v2.colors.neutral.highLight};
    }
  `}
`;
